/**
 * The ordering site's production domain. Firebase Hosting also serves the app
 * on its two default hosts, but an online payment provider only accepts the
 * domain each venue allow-lists — this one (see `ORDERING_ORIGIN` in
 * apps/functions/src/products/customerOrdering/payments/config.ts). So a
 * visitor who lands on a default host is moved to the same page here before
 * anything (cart cookie, anonymous sign-in, a pending payment) is set up under
 * the wrong origin.
 */
const ORDERING_HOST = "rewards.sally.app";

const FIREBASE_DEFAULT_HOSTS = [
  "sally-customer-ordering.web.app",
  "sally-customer-ordering.firebaseapp.com",
];

/**
 * Where this page should be instead, or `undefined` to stay — localhost,
 * Hosting preview channels (`…--channel.web.app`) and Firebase's reserved
 * `/__/` paths are left alone.
 */
export const canonicalOrderingUrl = (href: string): string | undefined => {
  const url = new URL(href);

  if (!FIREBASE_DEFAULT_HOSTS.includes(url.hostname)) return undefined;
  if (url.pathname.startsWith("/__/")) return undefined;

  url.protocol = "https:";
  url.host = ORDERING_HOST;

  return url.toString();
};
